/**
 * 区分 auditActionType（audit_logs.audit_action_type）
 * 出典：02 5.8（14 値）
 */
export const AUDIT_ACTION_TYPE_VALUES = [
  'create',
  'update',
  'delete',
  'restore',
  'bulkDelete',
  'readSensitive',
  'export',
  'import',
  'codeIssued',
  'loginSucceeded',
  'loginFailed',
  'logout',
  'permissionChanged',
  'sensitivePurged',
] as const;

export type AuditActionType = (typeof AUDIT_ACTION_TYPE_VALUES)[number];

export const AUDIT_ACTION_TYPE_LABELS: Readonly<Record<AuditActionType, string>> = {
  create: '登録',
  update: '変更',
  delete: '削除',
  restore: '復元',
  bulkDelete: '一括削除',
  readSensitive: '機微情報の参照',
  export: 'ファイル出力',
  import: '取込',
  codeIssued: '確認コード発行',
  loginSucceeded: 'ログイン成功',
  loginFailed: 'ログイン失敗',
  logout: 'ログアウト',
  permissionChanged: '権限変更',
  sensitivePurged: '機微情報の削除',
};
